import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';

@Component({
  selector: 'app-switch-input',
  templateUrl: './switch-input.component.html',
  styleUrls: ['./switch-input.component.scss'],
})
export class SwitchInputComponent {
  @Input() label: string = '';
  @Input() labelEn: string = '';
  @Input() labelDesc: string = '';
  @Input() value: boolean = false;
  @Input() index: number = 0;
  @Input() disableBtn = false;
  @Input() customClass: string = '';
  @Output() valueChanged = new EventEmitter<{ label: string; labelEn: string; value: boolean }>();
  @ViewChild('switchBtn') switchBtn!: ElementRef<HTMLInputElement>;

  changeValue(event: HTMLInputElement) {
    let value = event.checked;
    this.valueChanged.emit({
      label: this.label,
      labelEn: this.labelEn,
      value: value,
    });
  }
}
